export const CLIENT_ID_ERROR = 'The stored client ID is invalid';
